import {makeAutoObservable} from "mobx";
import {api} from "../../api";
import {ShipmentTypeDto, ShippingListItemDto} from "../../api/kpi";
import {ChartDataItemType, KpiShippingLoadParams, PrefixedShipmentType, sortedShipmentTypes} from "./commons";

class KpiShippingRecordReceiptExitStore {
    get dataReceipt(): ShippingListItemDto[] {
        return this._dataReceipt;
    }

    set dataReceipt(value: ShippingListItemDto[]) {
        this._dataReceipt = value;
    }
    get chartData(): ChartDataItemType[] {
        return this._chartData;
    }

    private set chartData(value: ChartDataItemType[]) {
        this._chartData = value;
    }

    get availableTypes(): ShipmentTypeDto[] {
        return this._availableTypes;
    }

    private set availableTypes(value: ShipmentTypeDto[]) {
        this._availableTypes = value;
    }

    get dataExit(): ShippingListItemDto[] {
        return this._dataExit;
    }

    private set dataExit(value: ShippingListItemDto[]) {
        this._dataExit = value;
    }

    private _chartData: ChartDataItemType[] = []
    private _availableTypes: ShipmentTypeDto[] = []
    private _dataExit: ShippingListItemDto[] = []
    private _dataReceipt: ShippingListItemDto[] = []

    constructor() {
        makeAutoObservable(this)
    }

    async load(query: KpiShippingLoadParams) {
        await Promise.all([
            this.loadExits(query),
            this.loadReceipts(query),
        ])
    }

    async loadExits(query: KpiShippingLoadParams) {
        try {
            const result = await api.kpi.api.listShippingRecordExits(query)
            this.dataExit = result.data.items || []
        } catch (ignored) {
            //TODO: mark as error
            this.dataExit = []
        }
        this.buildChartData()

    }

    async loadReceipts(query: KpiShippingLoadParams) {
        try {
            const result = await api.kpi.api.listShippingRecordReceipts(query)
            this.dataReceipt = result.data.items || []
        } catch (ignored) {
            //TODO: mark as error
            this.dataReceipt = []
        }
        this.buildChartData()

    }

    private buildChartData() {
        const {dataExit, dataReceipt} = this
        this.availableTypes = sortedShipmentTypes

        const groupedByDate: Record<string, ChartDataItemType> = {};

        dataExit.forEach(({date, shipmentType, count}) => {
            if (!groupedByDate[date]) {
                groupedByDate[date] = {
                    date,
                    receipt: 0,
                    exit: 0
                };
            }
            const current = groupedByDate[date]['exit'] || 0
            groupedByDate[date]['exit'] = current + count
            groupedByDate[date][`exit_${shipmentType}`] = count
        });

        dataReceipt.forEach(({date, shipmentType, count}) => {
            if (!groupedByDate[date]) {
                groupedByDate[date] = {
                    date,
                    receipt: 0,
                    exit: 0
                };
            }
            const current = groupedByDate[date]['receipt'] || 0
            groupedByDate[date]['receipt'] = current + count
            const r: PrefixedShipmentType = `receipt_${shipmentType}`
            groupedByDate[date][r] = count;
        });

        this.chartData = Object.values(groupedByDate)
            .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
            .map(a => {

                return {...a, date: (new Date(a.date)).toLocaleDateString('de')}
            })
    }
}

const kpiShippingRecordReceiptExitStore = new KpiShippingRecordReceiptExitStore()

export {
    kpiShippingRecordReceiptExitStore
}
